import clsx from 'clsx';

import css from './index.module.css';
import IconRepository from 'ui/Icon/icons';

type IconProps = {
  iconName: string;
  className?: string;
};

const Icon = ({ iconName, className }: IconProps) => {
  const IconAsset = IconRepository[iconName];

  return IconAsset ? (
    <i className={clsx(css.icon, className)} aria-hidden={true}>
      <IconAsset />
    </i>
  ) : null;
};

export default Icon;
